var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2625_5216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6654 14.6673L13.332 13.334M7.66536 14.0007C8.49707 14.0007 9.32063 13.8368 10.089 13.5186C10.8574 13.2003 11.5556 12.7338 12.1437 12.1457C12.7318 11.5576 13.1983 10.8594 13.5166 10.091C13.8349 9.32258 13.9987 8.49902 13.9987 7.66732C13.9987 6.83561 13.8349 6.01205 13.5166 5.24366C13.1983 4.47526 12.7318 3.77708 12.1437 3.18897C11.5556 2.60087 10.8574 2.13436 10.089 1.81608C9.32063 1.4978 8.49707 1.33398 7.66536 1.33398C5.98566 1.33398 4.37475 2.00124 3.18702 3.18897C1.99929 4.3767 1.33203 5.98761 1.33203 7.66732C1.33203 9.34702 1.99929 10.9579 3.18702 12.1457C4.37475 13.3334 5.98566 14.0007 7.66536 14.0007Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2625_5216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.0fa36b12dc86d6b6f444235f1706edd7.svg";
export { ForwardRef as ReactComponent };